import React from "react";
import { Box } from "@mui/material";
import MasterTheme from "./MasterTheme";
import styles from "./MasterData.module.scss";

export default function MasterPageShell({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <MasterTheme>
      <Box
        id="container-scroller"
        className={styles.page}
        sx={{ scrollMarginTop: 88 }}
      >
        {children}
      </Box>
    </MasterTheme>
  );
}
